import { fetchJson } from "@/services/api-client";
import { TaxExemption, TaxExemptionCreateData } from "@/types/tax-exemption";

export async function createTaxExemption(
  data: TaxExemptionCreateData,
): Promise<TaxExemption> {
  const { taxExemption } = await fetchJson<{ taxExemption: TaxExemption }>(
    "/api/tax-exemption",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
    { fallbackErrorMessage: "Failed to create organization tax exemption" },
  );

  return taxExemption;
}

export async function getTaxExemption(
  organizationId: string,
  forceRefresh = false,
): Promise<TaxExemption | null> {
  const url = forceRefresh
    ? `/api/tax-exemption?orgId=${organizationId}&_=${Date.now()}`
    : `/api/tax-exemption?orgId=${organizationId}`;

  const { taxExemption } = await fetchJson<{
    taxExemption?: TaxExemption | null;
  }>(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to get organization tax exemption" },
  );

  return taxExemption || null;
}
